import React, {useRef, useState} from 'react';
import Form from "../../../components/form/Form";

const TalentAvailabilityEditTab = ({
                                     opportunity,
                                     editable = true,
                                     onUpdate = async () => true,
                                     disabled
                                 }) => {
    const mapping = (model = {}) => {
        if (model.confirmed_availability) {
            model.confirmed_avg_hours_per_period = opportunity.project_position.avg_hours_per_period;
            model.confirmed_started_at = opportunity.project_position.started_at;
        }
        if (typeof model.confirmed_started_at === 'string') {
            model.confirmed_started_at = new Date(model.confirmed_started_at)
        }
        if (!TB.isNaN(parseInt(model.confirmed_avg_hours_per_period))) {
            model.confirmed_avg_hours_per_period = parseInt(model.confirmed_avg_hours_per_period)
        }

        return model;
    }

    const formRef = useRef(null);
    const fieldProps = ['confirmed_started_at', 'confirmed_avg_hours_per_period']

    const buildModel = (fromModel = opportunity?.job_candidate) => {
        let model = TB.pick(fromModel, fieldProps);

        const sameHours = !TB.isDefined(model.confirmed_avg_hours_per_period) ||
            model.confirmed_avg_hours_per_period === opportunity.project_position.avg_hours_per_period;

        const sameDate = !TB.isDefined(model.confirmed_started_at) || TB.moment(opportunity.project_position.started_at).isSame(model.confirmed_started_at, 'day');

        model.confirmed_availability = sameHours && sameDate;

        return mapping(model)
    }
    const [formModel, setFormModel] = useState(() => buildModel());

    const availRateFields = () => {

        // let profileDiscipline = opportunity.profileDisciplineForTalent(auth);

        return [
            {
                fields: {
                    availHeader: (
                        <div className="lg:flex flex-row items-center my-2">
                            <h3 className="proposal-tab-header mr-2 mb-0 mt-0">
                                Availability
                            </h3>
                            <p className="proposal-tab-subheader mb-0 mt-0">
                                The data populated below reflects the client’s request.
                                Please confirm and/or update.
                            </p>
                        </div>
                    )
                }
            },
            {
                className: 'avail-fields field-section',
                fields: [
                    {
                        className: 'avail-field-row field-section',
                        fields: {
                            confirmed_availability: {
                                className: 'm-0',
                                label: (
                                    <span className="text-black" style={{fontWeight: "normal"}}>
                                        By checking this box, I can confirm that <strong>{opportunity.user.fullName()}</strong> is available to start
                                        <b> {TB.moment(opportunity.project_position.started_at).format('ll')} </b>
                                        and can work up to <b>{opportunity.project_position.avg_hours_per_period} hrs per
                                        week</b>
                                    </span>
                                ),
                                disabled: disabled,
                                type: 'checkbox',
                                required: false
                            },
                        }
                    },
                    {
                        className: TB.mapClass("avail-edit-note field-section", {
                            "isVisible": !formModel.confirmed_availability
                        }),
                        groupClass: "avail-edit-group",
                        fields: {
                            confirmed_availability: {
                                component: (
                                    <p className="text-bold mb-0">
                                        Proposed availability for this role is:
                                    </p>
                                ),
                            },
                        }
                    },
                    {
                        className: 'avail-field-row field-section',
                        fields: {
                            hourly_rate_label: {
                                component: (
                                    <label className="avail-label col-form-label whitespace-nowrap" htmlFor="confirmed_started_at">
                                        Date <strong className="text-[12px]">{opportunity.user.fullName()}</strong> can start
                                    </label>
                                ),
                                style: { padding: '0 15px', marginBottom: 0, width: 'auto', flexBasis: 'unset' }
                            },
                            confirmed_started_at: {
                                label: false,
                                type: 'date',
                                required: true,
                                columns: 5,
                                disabled: disabled || formModel.confirmed_availability,
                                style: { padding: '0 15px', marginBottom: 0 },
                                minDate: opportunity.minDate(),
                                maxDate: opportunity.maxDate(),
                                datePickerProps: {
                                    // activeStartDate: opportunity.requestedDate(),
                                    showFixedNumberOfWeeks: true,
                                    tileClassName: ({activeStartDate, date, view}) => {
                                        return TB.moment(opportunity.requestedDate())
                                            .isSame(date, 'day') ? 'target-date' : (
                                            (date >= opportunity.minDate() && date <= opportunity.maxDate()) ? 'active-range' : ''
                                        )
                                    }
                                },
                                onDateSelected: async (date) => {

                                    console.log('onDateSelected', date);

                                    let updatedModel = {
                                        confirmed_started_at: date
                                    }
                                    setFormModel({
                                        ...formModel,
                                        ...updatedModel
                                    })
                                    formRef?.current.updateInputsWithValue(updatedModel)

                                },
                                showCalendar: false
                            },
                        },
                    },
                    {
                        className: 'avail-field-row field-section',
                        fields: {
                            hourly_rate_label: {
                                component: (
                                    <label className="avail-label col-form-label whitespace-nowrap"
                                           htmlFor="confirmed_avg_hours_per_period">
                                        <strong className="text-[12px]">{opportunity.user.fullName()}</strong> is available
                                    </label>
                                ),
                                style: { padding: '0 15px', marginBottom: 0, width: 'auto', flexBasis: 'unset' },
                            },
                            confirmed_avg_hours_per_period: {
                                label: false,
                                className: 'field hrs_per_week',
                                disabled: disabled || formModel.confirmed_availability,
                                type: 'number',
                                required: true,
                                columns: 5,
                                style: { padding: '0 15px', marginBottom: 0 },
                                validation: {
                                    rules: {
                                        availableHoursValidation: function (model, value) {
                                            let min = parseInt(value);
                                            if (TB.isNumber(min) && min < 1) {
                                                return "Must be greater than 0 hours";
                                            } else if (TB.isNumber(min) && min > opportunity.project_position.avg_hours_per_period) {
                                                return `Must be less than or equal to ${opportunity.project_position.avg_hours_per_period} hours`;
                                            }
                                            return true
                                        },
                                        isInt: true
                                    }
                                },
                                addonAfter: (
                                    <span className="rate-note text-bold">
                                        hours per week.
                                    </span>
                                )
                            },
                        },
                    }
                ]

            },
        ];
    }


    const hasFormModelChanged = () => {
        let opp = buildModel();
        let model = buildModel(formModel);
        return !TB.isEqual(opp, model)
    }

    const resetForm = async () => {
        let model = buildModel()

        model = mapping({...model});
        console.log('resetForm', model.confirmed_availability)

        await setFormModel(model);

        await formRef.current.forceReset({...model});
        await formRef.current.formRef.current.formsyForm.setFormPristine(true);
    }

    const submitForm = async () => {
        let invalid = formRef.current.forceValidate(formModel);
        if (invalid) {
            console.log('invalid', invalid)
            return;
        }
        let success = await onUpdate({job_candidate: {...formModel, talent_proposed_at: new Date()}})

        // if (success) {
        //     await resetForm();
        // }

    }
    return (
        <React.Fragment>
            <div className="opp-talent-proposal-form">
                <Form
                    ref={formRef}
                    background={"transparent"}
                    mapping={mapping}
                    onSubmit={submitForm}
                    submitButton={false}
                    isDisabled={disabled}
                    model={formModel}
                    fields={availRateFields()}
                    className={
                        TB.mapClass({
                            'no-edit': !editable
                        })
                    }
                    onChange={async (model) => {
                        let reset = !formModel.confirmed_availability && model.confirmed_availability;

                        await setFormModel(mapping({
                                ...formModel, ...model
                            }
                        ))

                        if (reset) {
                            return formRef?.current.updateInputsWithValue({
                                confirmed_avg_hours_per_period: opportunity.project_position.avg_hours_per_period,
                                confirmed_started_at: opportunity.project_position.started_at
                            })
                        }
                    }}>
                    {editable && (
                        <div className="mt-3 flex flex-row justify-end">
                            <button type="submit" className="btn btn-primary mr-3"
                                    disabled={disabled || !hasFormModelChanged()}>
                                Save
                            </button>
                            <button className="btn btn-outline-dark"
                                    type="button" onClick={resetForm}
                                    disabled={disabled || !hasFormModelChanged()}>
                                Cancel
                            </button>
                        </div>
                    )}
                </Form>

            </div>

        </React.Fragment>
    );
};

const styles = {
    fieldSectionCol: {
        flexDirection: 'column',
        alignItems: 'stretch'
    },
    fieldSection: {
        margin: '0 -15px',
        flexDirection: 'row'
    },
    field: {
        padding: 0,
    },
    rowField: {padding: '0 15px', marginBottom: 0}
};


export default TalentAvailabilityEditTab;